import React, { useState } from "react";
import "../../styles/intake.css"; // Make sure styles exist or update the path

const languageOptions = [
  "English", "Spanish", "Chinese (Mandarin)", "Chinese (Cantonese)", "Vietnamese",
  "Korean", "Tagalog", "Arabic", "Russian", "Portuguese", "French", "Japanese",
  "Hindi", "Urdu", "Persian (Farsi)", "Armenian", "Thai", "German", "Italian",
  "Polish", "Bengali", "Punjabi", "Turkish", "Somali", "Hmong", "Greek",
  "Hebrew", "Dutch", "Swedish", "Finnish", "Danish", "Norwegian",
  "Hungarian", "Czech", "Slovak", "Romanian"
];

export default function LanguageSelector({ selectedLanguages = [], setSelectedLanguages }) {
    const [open, setOpen] = useState(false);
  
    const handleToggle = (language) => {
      const updated = selectedLanguages.includes(language)
        ? selectedLanguages.filter((l) => l !== language)
        : [...selectedLanguages, language];
      setSelectedLanguages(updated);
    };
  
    return (
      <div className="dropdown-wrapper">
        <div className="dropdown-header" onClick={() => setOpen(!open)}>
          {selectedLanguages.length > 0 ? selectedLanguages.join(", ") : "Select languages..."}
          <span className="arrow">{open ? "▲" : "▼"}</span>
        </div>
        {open && (
          <div className="dropdown-list">
            {languageOptions.map((language) => (
              <label key={language} className="dropdown-item">
                <input
                  type="checkbox"
                  checked={selectedLanguages.includes(language)}
                  onChange={() => handleToggle(language)}
                />
                {language}
              </label>
            ))}
          </div>
        )}
      </div>
    );
  }
  